import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateCommunicationComponent } from './create-communication/create-communication.component';
import { BikeShopPostsService } from '../../../../../services/bike-shop-posts.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { BroadcastService } from '../../../../../services/broadcast.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html',
  styleUrls: ['./communication.component.scss'],
})
export class CommunicationComponent implements OnInit {
  public partnerID: any;
  public posts: any = [];
  public loading: boolean = false;

  constructor(
    public modalService: NgbModal,
    public postsService: BikeShopPostsService,
    public helpersService: HelpersService,
    public broadcastService: BroadcastService,
  ) {
    this.partnerID = this.helpersService.getPartnerId();
  }

  ngOnInit() {
    this.getPosts();
  }

  filter(selectedFilter) {
    this.getPosts();
  }

  getPosts() {
    this.loading = true;
    this.postsService.getPosts(this.partnerID).subscribe((posts) => {
      this.posts = posts;
      this.loading = false;
    });
  }

  editPost(item) {
    const modalRef = this.modalService.open(CreateCommunicationComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.post = JSON.parse(JSON.stringify(item));
    modalRef.componentInstance.partnerID = this.partnerID;
    modalRef.result.then(
      (result) => {
        this.getPosts();
      },
      (onrejected) => {},
    );
  }

  createPost() {
    const modalRef = this.modalService.open(CreateCommunicationComponent, {
      size: 'lg',
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.post = null;
    modalRef.componentInstance.partnerID = this.partnerID;
    modalRef.result.then(
      (result) => {
        this.getPosts();
      },
      (onrejected) => {},
    );
  }
}
